import { PaletteGrey800 as t, TypographyDesktopBody2LetterSpacing as d, TypographyDesktopBody2LineHeight as c, TypographyDesktopBody2Size as u, TypographyDesktopBody3Weight as S, TypographyDesktopBody2Family as H, PaletteCommonBlack as o, PaletteGrey600 as i, ShapeBorderRadiusMedium as a, TypographyMobileBody2LetterSpacing as r, TypographyMobileBody2LineHeight as p, TypographyMobileBody2Size as n, TypographyMobileBody2Weight as m, PaletteBackgroundPaper as y, PaletteSecondaryMain as g, TransitionsEasingSharp as k, TransitionsEasingEaseOut as f, TransitionsEasingEaseInOut as b, TransitionsEasingEaseIn as D, TransitionsDurationStandard as M, TransitionsDurationShortest as B, TransitionsDurationShorter as L, TransitionsDurationShort as F, TransitionsDurationLeavingScreen as P, TransitionsDurationEnteringScreen as z, TransitionsDurationComplex as W, ZIndexSpeedDial as x, ZIndexSnackbar as C, ZIndexModal as I, ZIndexMobileStepper as v, ZIndexDrawer as E, ZIndexTooltip as w, ZIndexAppBar as G, ShadowsSecondary as O, ShadowsPrimary as R, TypographyMobileCaptionLetterSpacing as A, TypographyMobileCaptionLineHeight as Z, TypographyMobileCaptionSize as X, TypographyMobileCaptionFamily as N, TypographyMobileButton2LetterSpacing as U, TypographyMobileButton2LineHeight as _, TypographyMobileButton2Size as j, TypographyMobileButton2Family as q, TypographyMobileButton1LetterSpacing as J, TypographyMobileButton1LineHeight as K, TypographyMobileButton1Size as Q, TypographyMobileButton1Family as V, TypographyMobileBody3LetterSpacing as Y, TypographyMobileBody3LineHeight as $, TypographyMobileBody3Size as ee, TypographyMobileBody3Family as te, TypographyMobileBody2Family as oe, TypographyMobileBody1LetterSpacing as ie, TypographyMobileBody1LineHeight as ae, TypographyMobileBody1Size as re, TypographyMobileBody1Family as pe, TypographyMobileH6LetterSpacing as ne, TypographyMobileH6LineHeight as ye, TypographyMobileH6Size as ge, TypographyMobileH6Family as le, TypographyMobileH5LetterSpacing as he, TypographyMobileH5LineHeight as se, TypographyMobileH5Size as Te, TypographyMobileH5Family as Se, TypographyMobileH4LetterSpacing as de, TypographyMobileH4LineHeight as ce, TypographyMobileH4Size as ue, TypographyMobileH4Family as He, TypographyMobileH3LetterSpacing as me, TypographyMobileH3LineHeight as ke, TypographyMobileH3Size as fe, TypographyMobileH3Family as be, TypographyMobileH2LetterSpacing as De, TypographyMobileH2LineHeight as Me, TypographyMobileH2Size as Be, TypographyMobileH2Family as Le, TypographyMobileH1LetterSpacing as Fe, TypographyMobileH1LineHeight as Pe, TypographyMobileH1Size as ze, TypographyMobileH1Family as We, TypographyDesktopCaptionLetterSpacing as xe, TypographyDesktopCaptionLineHeight as Ce, TypographyDesktopCaptionSize as Ie, TypographyDesktopCaptionWeight as ve, TypographyDesktopCaptionFamily as Ee, TypographyDesktopButton3LetterSpacing as we, TypographyDesktopButton3LineHeight as Ge, TypographyDesktopButton3Size as Oe, TypographyDesktopButton3Weight as Re, TypographyDesktopButton3Family as Ae, TypographyDesktopButton2LetterSpacing as Ze, TypographyDesktopButton2LineHeight as Xe, TypographyDesktopButton2Size as Ne, TypographyDesktopButton2Weight as Ue, TypographyDesktopButton2Family as _e, TypographyDesktopButton1LetterSpacing as je, TypographyDesktopButton1LineHeight as qe, TypographyDesktopButton1Size as Je, TypographyDesktopButton1Weight as Ke, TypographyDesktopButton1Family as Qe, TypographyDesktopBody3LetterSpacing as Ve, TypographyDesktopBody3LineHeight as Ye, TypographyDesktopBody3Size as $e, TypographyDesktopBody3Family as et, TypographyDesktopBody1LetterSpacing as tt, TypographyDesktopBody1LineHeight as ot, TypographyDesktopBody1Size as it, TypographyDesktopBody1Weight as at, TypographyDesktopBody1Family as rt, TypographyDesktopH6LetterSpacing as pt, TypographyDesktopH6LineHeight as nt, TypographyDesktopH6Size as yt, TypographyDesktopH6Weight as gt, TypographyDesktopH6Family as lt, TypographyDesktopH5LetterSpacing as ht, TypographyDesktopH5LineHeight as st, TypographyDesktopH5Size as Tt, TypographyDesktopH5Weight as St, TypographyDesktopH5Family as dt, TypographyDesktopH4LetterSpacing as ct, TypographyDesktopH4LineHeight as ut, TypographyDesktopH4Size as Ht, TypographyDesktopH4Weight as mt, TypographyDesktopH4Family as kt, TypographyDesktopH3LetterSpacing as ft, TypographyDesktopH3LineHeight as bt, TypographyDesktopH3Size as Dt, TypographyDesktopH3Weight as Mt, TypographyDesktopH3Family as Bt, TypographyDesktopH2LetterSpacing as Lt, TypographyDesktopH2LineHeight as Ft, TypographyDesktopH2Size as Pt, TypographyDesktopH2Weight as zt, TypographyDesktopH2Family as Wt, TypographyDesktopH1LetterSpacing as xt, TypographyDesktopH1LineHeight as Ct, TypographyDesktopH1Size as It, TypographyDesktopH1Weight as vt, TypographyDesktopH1Family as Et, FontSizeDefault as wt, FontWeightBlack as Gt, FontWeightBold as Ot, FontWeightMedium as Rt, FontWeightNormal as At, FontWeightLight as Zt, FontFamilyDefault as Xt, PalettePrimaryLight as Nt, PalettePrimaryMain as Ut, PalettePrimaryDark as _t, PalettePrimaryContrastText as jt, PaletteSecondaryLight as qt, PaletteSecondaryDark as Jt, PaletteSecondaryContrastText as Kt, PaletteTertiaryLight as Qt, PaletteTertiaryMain as Vt, PaletteTertiaryDark as Yt, PaletteTertiaryContrastText as $t, PaletteErrorLight as eo, PaletteErrorMain as to, PaletteErrorDark as oo, PaletteErrorContrastText as io, PaletteWarningLight as ao, PaletteWarningMain as ro, PaletteWarningDark as po, PaletteWarningContrastText as no, PaletteInfoLight as yo, PaletteInfoMain as go, PaletteInfoDark as lo, PaletteInfoContrastText as ho, PaletteSuccessLight as so, PaletteSuccessMain as To, PaletteSuccessDark as So, PaletteSuccessContrastText as co, PaletteGrey400 as l, PaletteGrey700 as h, PaletteGrey200 as s, PaletteGrey100 as T, PaletteGrey1000 as uo, PaletteGrey900 as Ho, PaletteGrey500 as mo, PaletteGrey300 as ko, PaletteGrey50 as fo, PaletteGrey30 as bo, PaletteGrey0 as Do, PaletteActionDisabled as Mo, PaletteTextHigh as Bo, PaletteTextMedium as Lo, PaletteTextLow as Fo, PaletteDividerDefault as Po, PaletteBrandSupport5 as zo, PaletteBrandSupport4 as Wo, PaletteBrandSupport3 as xo, PaletteBrandSupport2 as Co, PaletteBrandSupport1 as Io, PaletteBackgroundDefault as vo, PaletteCommonWhite as Eo, DirectionDefault as wo, ContainerXl as Go, ContainerLg as Oo, ContainerMd as Ro, ContainerSm as Ao, ContainerXs as Zo, BreakpointsXl as Xo, BreakpointsLg as No, BreakpointsMd as Uo, BreakpointsSm as _o, BreakpointsXs as jo, ShapeBorderRadiusLarge as qo, ShapeBorderRadius as Jo, SpacingDefault as Ko, BackdropDefaultColor as Qo, BackdropDefaultFilter as Vo } from "../default/index.js";
const e = {
  fontFamily: H,
  fontWeight: S,
  fontSize: u,
  lineHeight: c,
  letterSpacing: d
}, $o = {
  backdrop: {
    filter: Vo,
    color: Qo
  },
  spacing: Ko,
  shape: {
    borderRadius: Jo,
    borderRadiusMedium: a,
    borderRadiusLarge: qo
  },
  breakpoints: {
    values: {
      xs: jo,
      sm: _o,
      md: Uo,
      lg: No,
      xl: Xo
    }
  },
  container: {
    values: {
      xs: Zo,
      sm: Ao,
      md: Ro,
      lg: Oo,
      xl: Go
    }
  },
  direction: wo,
  palette: {
    common: {
      white: Eo,
      black: o
    },
    background: {
      default: vo,
      paper: y
    },
    brandSupport: {
      1: Io,
      2: Co,
      3: xo,
      4: Wo,
      5: zo
    },
    divider: Po,
    text: {
      low: Fo,
      medium: Lo,
      high: Bo
    },
    action: {
      disabled: Mo
    },
    grey: {
      0: Do,
      30: bo,
      50: fo,
      100: T,
      200: s,
      300: ko,
      400: l,
      500: mo,
      600: i,
      700: h,
      800: t,
      900: Ho,
      1e3: uo,
      A100: T,
      A200: s,
      A700: h,
      A400: l
    },
    success: {
      contrastText: co,
      dark: So,
      main: To,
      light: so
    },
    info: {
      contrastText: ho,
      dark: lo,
      main: go,
      light: yo
    },
    warning: {
      contrastText: no,
      dark: po,
      main: ro,
      light: ao
    },
    error: {
      contrastText: io,
      dark: oo,
      main: to,
      light: eo
    },
    tertiary: {
      contrastText: $t,
      dark: Yt,
      main: Vt,
      light: Qt
    },
    secondary: {
      contrastText: Kt,
      dark: Jt,
      main: g,
      light: qt
    },
    primary: {
      contrastText: jt,
      dark: _t,
      main: Ut,
      light: Nt
    }
  },
  typography: {
    fontFamily: Xt,
    fontWeightLight: Zt,
    fontWeightRegular: At,
    fontWeightMedium: Rt,
    fontWeightBold: Ot,
    fontWeightBolder: Gt,
    fontSize: wt,
    h1: {
      fontFamily: Et,
      fontWeight: vt,
      fontSize: It,
      lineHeight: Ct,
      letterSpacing: xt
    },
    h2: {
      fontFamily: Wt,
      fontWeight: zt,
      fontSize: Pt,
      lineHeight: Ft,
      letterSpacing: Lt
    },
    h3: {
      fontFamily: Bt,
      fontWeight: Mt,
      fontSize: Dt,
      lineHeight: bt,
      letterSpacing: ft
    },
    h4: {
      fontFamily: kt,
      fontWeight: mt,
      fontSize: Ht,
      lineHeight: ut,
      letterSpacing: ct
    },
    h5: {
      fontFamily: dt,
      fontWeight: St,
      fontSize: Tt,
      lineHeight: st,
      letterSpacing: ht
    },
    h6: {
      fontFamily: lt,
      fontWeight: gt,
      fontSize: yt,
      lineHeight: nt,
      letterSpacing: pt
    },
    body1: {
      fontFamily: rt,
      fontWeight: at,
      fontSize: it,
      lineHeight: ot,
      letterSpacing: tt
    },
    body2: e,
    body3: {
      fontFamily: et,
      fontWeight: S,
      fontSize: $e,
      lineHeight: Ye,
      letterSpacing: Ve
    },
    button1: {
      fontFamily: Qe,
      fontWeight: Ke,
      fontSize: Je,
      lineHeight: qe,
      letterSpacing: je,
      textTransform: "none"
    },
    button2: {
      fontFamily: _e,
      fontWeight: Ue,
      fontSize: Ne,
      lineHeight: Xe,
      letterSpacing: Ze,
      textTransform: "none"
    },
    button3: {
      fontFamily: Ae,
      fontWeight: Re,
      fontSize: Oe,
      lineHeight: Ge,
      letterSpacing: we,
      textTransform: "none"
    },
    caption: {
      fontFamily: Ee,
      fontWeight: ve,
      fontSize: Ie,
      lineHeight: Ce,
      letterSpacing: xe
    },
    mobile: {
      h1: {
        fontFamily: We,
        fontSize: ze,
        lineHeight: Pe,
        letterSpacing: Fe
      },
      h2: {
        fontFamily: Le,
        fontSize: Be,
        lineHeight: Me,
        letterSpacing: De
      },
      h3: {
        fontFamily: be,
        fontSize: fe,
        lineHeight: ke,
        letterSpacing: me
      },
      h4: {
        fontFamily: He,
        fontSize: ue,
        lineHeight: ce,
        letterSpacing: de
      },
      h5: {
        fontFamily: Se,
        fontSize: Te,
        lineHeight: se,
        letterSpacing: he
      },
      h6: {
        fontFamily: le,
        fontSize: ge,
        lineHeight: ye,
        letterSpacing: ne
      },
      body1: {
        fontFamily: pe,
        fontSize: re,
        lineHeight: ae,
        letterSpacing: ie
      },
      body2: {
        fontFamily: oe,
        fontSize: n,
        lineHeight: p,
        letterSpacing: r
      },
      body3: {
        fontFamily: te,
        fontSize: ee,
        lineHeight: $,
        letterSpacing: Y
      },
      button1: {
        fontFamily: V,
        fontSize: Q,
        lineHeight: K,
        letterSpacing: J,
        textTransform: "none"
      },
      button2: {
        fontFamily: q,
        fontSize: j,
        lineHeight: _,
        letterSpacing: U,
        textTransform: "none"
      },
      caption: {
        fontFamily: N,
        fontSize: X,
        lineHeight: Z,
        letterSpacing: A
      }
    }
  },
  shadow: {
    primary: R,
    secondary: O
  },
  zIndex: {
    appBar: G,
    tooltip: w,
    drawer: E,
    mobileStepper: v,
    modal: I,
    snackbar: C,
    speedDial: x
  },
  transitions: {
    duration: {
      complex: W,
      enteringScreen: z,
      leavingScreen: P,
      short: F,
      shorter: L,
      shortest: B,
      standard: M
    },
    easing: {
      easeIn: D,
      easeInOut: b,
      easeOut: f,
      sharp: k
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          scrollBehavior: "smooth"
        },
        body: {
          color: g,
          backgroundColor: y,
          fontWeight: m,
          fontSize: n,
          lineHeight: p,
          letterSpacing: r
        }
      }
    },
    // TODO should remove all these styles after mapping all component on DS and Figma.
    MuiModal: {
      styleOverrides: {
        root: {
          "& .MuiPaper-root": {
            borderRadius: a
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          ...e,
          "& .MuiInputBase-input": {
            padding: "12px 0 14px",
            "&:-webkit-autofill": {
              transition: "background-color 999999s"
            },
            "&:-webkit-autofill:focus": {
              transition: "background-color 999999s"
            },
            "&:-webkit-autofill:hover": {
              transition: "background-color 999999s"
            }
          }
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          ...e,
          color: i,
          "&.Mui-focused": {
            color: o
          }
        }
      }
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          height: 2,
          "& .MuiSlider-thumb": {
            width: 12,
            height: 12
          },
          "& span.MuiSlider-valueLabel": {
            background: "none",
            bottom: -52
          }
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        root: {
          ...e,
          "&.MuiInput-underline:before, &.MuiInput-underline:hover:not(.Mui-disabled):before": {
            borderColor: t
          }
        }
      }
    }
  }
};
export {
  $o as DEFAULT_THEME
};
//# sourceMappingURL=default.js.map
